import { img } from "./images";

const siteOrigin = (
  (import.meta.env.VITE_SITE_URL as string | undefined) || "https://avclinic.co.in"
).replace(/\/+$/, "");

export const site = {
  name: "AV Clinic",
  tagline: "Skin · Hair · Aesthetic · Urology & Andrology",
  city: "Krishnagiri",
  region: "Tamil Nadu",
  address:
    "No. 9, 3rd Cross, Co-Operative Colony, MGM Mansion Opposite, Krishnagiri – 635001, Tamil Nadu, India",
  shortAddress: "Co-Operative Colony, Krishnagiri – 635001",
  phones: [
    { label: "Dr. M. V. Arun Vijaiyan", number: "+919442445579", display: "+91 94424 45579" },
    { label: "Dr. M. Vanitha", number: "+919489828646", display: "+91 94898 28646" },
  ],
  email: "avclinic82@gmail.com",
  whatsapp: "919442445579",
  mapsEmbed:
    "https://www.google.com/maps?q=A+V+Clinic+Krishnagiri+Co-Operative+Colony&output=embed",
  mapsDirections:
    "https://www.google.com/maps/dir/?api=1&destination=A+V+Clinic+Krishnagiri+Co-Operative+Colony",
  hours: [
    { days: "Monday – Saturday", time: "10:00 AM – 1:30 PM / 5:00 PM – 8:30 PM" },
    { days: "Sunday", time: "By Appointment" },
  ],
  url: siteOrigin,
  ogImage: img.clinicFront,
};

export const waLink = (text: string) =>
  `https://wa.me/${site.whatsapp}?text=${encodeURIComponent(text)}`;